'use client';

import Button from '@mui/material/Button';

import { RADIUS, SURFACE } from 'src/theme/ui-tokens';

import { Iconify } from 'src/components/iconify';

/**
 * 공유 링크 복사 단추 — 소재 상세 · 브랜드 허브 상세 · 크리에이터 허브 상세가 같은 단추를 쓴다.
 *
 * ⚠️ **줄·카드의 동작은 한 꼴이다**(면 없음 · 흐린 색) — 담기(`+`)·북마크·즐겨찾기 별과 나란히
 *   서는 자리라 혼자 색이 있으면 셋 중 하나만 튄다.
 * @param size `sm` 22×22(소재 상세 발치 — `PostCardBookmarkOverlay` 방아쇠와 같은 치수) ·
 *   `md` 28×28(허브 상세 머리 — `HubStarButton` 과 같은 치수)
 */
export function ShareLinkButton({ onClick, size = 'sm' }: { onClick: () => void; size?: 'sm' | 'md' }) {
  const box = size === 'md' ? 28 : 22;
  return (
    <Button
      size="small"
      variant="text"
      color="inherit"
      aria-label="공유 링크 복사"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      sx={{
        borderRadius: RADIUS.sm,
        p: 0,
        minWidth: box,
        minHeight: 0,
        width: box,
        height: box,
        color: 'text.disabled',
        '&:hover': { bgcolor: SURFACE.hover, color: 'text.primary' },
      }}
    >
      <Iconify icon="solar:share-linear" width={size === 'md' ? 16 : 14} />
    </Button>
  );
}
